// icon:boxes | Bootstrap https://icons.getbootstrap.com/ | Bootstrap
import * as React from "react";

function TableIcon(props) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path
        d="M448 96v128H288V96h160zm0 192v128H288V288h160zm-224-64H64V96h160v128zM64 288h160v128H64V288zm0-256C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"/>
    </svg>
  );
}

export default TableIcon;
